// Accordian.js 

export const accordian = () => {
    //console.log("Accordian.js loaded");
    const accordians = document.querySelectorAll('[vdx-accordian]'); 
    
    accordians.forEach(accordian => {
        accordian.addEventListener('click', () => {
            accordian.classList.toggle('vdx--open');
            accordian.querySelectorAll('*').forEach(child => child.classList.toggle('vdx--open'));
        });
    });
}   